/**
 * Cliente Supabase inyectable para uso en shared.
 * La app debe llamar setSupabaseClient(supabase) en su entry (main.tsx) tras crear el cliente.
 */
import type { SupabaseClient } from '@supabase/supabase-js';

let client: SupabaseClient | null = null;

export function setSupabaseClient(c: SupabaseClient): void {
  client = c;
}

export function getSupabaseClient(): SupabaseClient {
  if (!client) {
    throw new Error(
      'Supabase client not set. Call setSupabaseClient(supabase) in your app entry (e.g. main.tsx) before using shared code that needs Supabase.'
    );
  }
  return client;
}
